var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "page-content", attrs: { id: "ppes-form" } },
    [
      _c(
        "Titlebar",
        { attrs: { backPath: "/parameters/ppes", incrustation: "fa-shield" } },
        [
          !_vm.editMode
            ? _c("h1", [
                _c("span", [_vm._v(_vm._s(_vm.$t("ppes.titles.new")))]),
                _vm._v(" "),
                _vm.nameList ? _c("span", [_vm._v('"')]) : _vm._e(),
                _c("span", { staticStyle: { "font-weight": "900" } }, [
                  _vm._v(_vm._s(_vm.nameList)),
                ]),
                _vm.nameList ? _c("span", [_vm._v('"')]) : _vm._e(),
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.editMode ? _c("h1", [_vm._v(_vm._s(_vm.nameList))]) : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "row justify-content-center full-height" }, [
        _c(
          "div",
          { staticClass: "col-6" },
          [
            _c("UiCard", [
              _c("form", { staticClass: "form p-0" }, [
                _c("h2", [
                  _c("i", { staticClass: "fa fa-list" }),
                  _vm._v(_vm._s(_vm.$t("ppes.phonebook"))),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-row row" }, [
                  _c("label", { staticClass: "col-4" }, [
                    _vm._v(_vm._s(_vm.$t("ppes.cols.list"))),
                  ]),
                  _vm._v(" "),
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.nameList,
                        expression: "nameList",
                      },
                      { name: "validate", rawName: "v-validate" },
                    ],
                    staticClass: "form-input col",
                    class: { invalid: _vm.errors.has("nameList") },
                    attrs: {
                      type: "text",
                      id: "nameList",
                      name: "nameList",
                      "data-vv-rules": "required",
                      "data-vv-validate-on": "none",
                      "data-vv-as": _vm.$t("ppes.cols.name"),
                    },
                    domProps: { value: _vm.nameList },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.nameList = $event.target.value
                      },
                    },
                  }),
                  _vm._v(" "),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.showErrors["nameList"] &&
                            _vm.errors.has("nameList"),
                          expression:
                            "showErrors['nameList'] && errors.has('nameList')",
                        },
                      ],
                      staticClass: "form-input-error",
                      on: {
                        click: function ($event) {
                          return _vm.hideError("nameList")
                        },
                      },
                    },
                    [_vm._v(_vm._s(_vm.errors.first("nameList")))]
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-row row" }, [
                  _c("label", { staticClass: "col-4" }, [
                    _vm._v(
                      "\n                            " +
                        _vm._s(_vm.$t("ppes.cols.mode")) +
                        "\n                            "
                    ),
                    _c(
                      "span",
                      {
                        staticStyle: {
                          position: "relative",
                          "margin-left": "10px",
                        },
                      },
                      [
                        _c("i", {
                          staticClass:
                            "fa fa-question-circle text-warning warning-beepiz-remote-monitoring show",
                        }),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "tooltip left",
                            staticStyle: {
                              width: "250px",
                              top: "-2px",
                              left: "37px",
                            },
                          },
                          [
                            _c(
                              "h5",
                              {
                                staticStyle: {
                                  color: "#ffc107",
                                  "font-weight": "700",
                                },
                              },
                              [_vm._v(_vm._s(_vm.$t("ppes.tooltip.title")))]
                            ),
                            _vm._v(
                              "\n                                        " +
                                _vm._s(
                                  _vm.$t("ppes.tooltip.content", {
                                    univers: _vm.Utils().getApplicationName(),
                                  })
                                ) +
                                "\n                                    "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "col" },
                    [
                      _c("UiSwitch", {
                        attrs: {
                          labelYes: _vm.$t("ppes.verification.all"),
                          labelNo: _vm.$t("ppes.verification.missing"),
                        },
                        model: {
                          value: _vm.modeListBool,
                          callback: function ($$v) {
                            _vm.modeListBool = $$v
                          },
                          expression: "modeListBool",
                        },
                      }),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "form-row row" }, [
                  _c("label", { staticClass: "col-4" }, [
                    _vm._v(_vm._s(_vm.$t("ppes.form.notification"))),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-8 simple-checkbox" }, [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.notificationList,
                          expression: "notificationList",
                        },
                      ],
                      attrs: {
                        "false-value": 0,
                        "true-value": 1,
                        id: "notification",
                        type: "checkbox",
                      },
                      domProps: {
                        checked: Array.isArray(_vm.notificationList)
                          ? _vm._i(_vm.notificationList, null) > -1
                          : _vm._q(_vm.notificationList, 1),
                      },
                      on: {
                        change: function ($event) {
                          var $$a = _vm.notificationList,
                            $$el = $event.target,
                            $$c = $$el.checked ? 1 : 0
                          if (Array.isArray($$a)) {
                            var $$v = null,
                              $$i = _vm._i($$a, $$v)
                            if ($$el.checked) {
                              $$i < 0 &&
                                (_vm.notificationList = $$a.concat([$$v]))
                            } else {
                              $$i > -1 &&
                                (_vm.notificationList = $$a
                                  .slice(0, $$i)
                                  .concat($$a.slice($$i + 1)))
                            }
                          } else {
                            _vm.notificationList = $$c
                          }
                        },
                      },
                    }),
                    _vm._v(" "),
                    _c("label", { attrs: { for: "notification" } }, [
                      _vm._v(_vm._s(_vm.$t("ppes.verification.mailInfo"))),
                    ]),
                  ]),
                ]),
              ]),
            ]),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "col-6 col-xl-6 full-height" },
          [
            _c("UiCard", [
              _c(
                "form",
                { staticClass: "form full-height ppes-selection p-0" },
                [
                  _c("h2", [
                    _c("i", { staticClass: "fa fa-shield" }),
                    _vm._v(_vm._s(_vm.$t("ppes.contacts"))),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "selected-ppes" },
                    [
                      _c("h3", [
                        _vm._v(_vm._s(_vm.$t("ppes.selected")) + " "),
                        _vm.itemsList.length > 0
                          ? _c("span", { staticClass: "badge" }, [
                              _vm._v(_vm._s(_vm.itemsList.length)),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _vm.itemsList && _vm.itemsList.length > 0
                        ? _c(
                            "draggable",
                            {
                              staticClass: "ppes-inner",
                              attrs: {
                                element: "div",
                                list: _vm.itemsList,
                                options: _vm.draggableOptions,
                              },
                            },
                            _vm._l(_vm.itemsList, function (item, index) {
                              return _c("div", { staticClass: "ppe-item" }, [
                                _c("span", {
                                  staticClass: "ppe",
                                  class: ["ppe" + item.id],
                                }),
                                _vm._v(" "),
                                _c("span", { staticClass: "ppe-label" }, [
                                  _vm._v(_vm._s(item.name)),
                                ]),
                                _vm._v(" "),
                                _c("i", { staticClass: "fa fa-arrows-v" }),
                                _vm._v(" "),
                                _c("i", {
                                  staticClass: "fa fa-times",
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeItem(index)
                                    },
                                  },
                                }),
                              ])
                            }),
                            0
                          )
                        : _c("div", { staticClass: "no-item" }, [
                            _vm._v(
                              "\n                            " +
                                _vm._s(_vm.$t("ppes.form.noPpes")) +
                                "\n                        "
                            ),
                          ]),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "unselected-ppes" }, [
                    _c("h3", [_vm._v(_vm._s(_vm.$t("ppes.unselected")))]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "ppes-inner" },
                      _vm._l(_vm.unselectedItems, function (item) {
                        return _c(
                          "span",
                          {
                            staticClass: "ppe-item",
                            on: {
                              click: function ($event) {
                                return _vm.addItem(item)
                              },
                            },
                          },
                          [
                            _c("span", {
                              staticClass: "ppe",
                              class: ["ppe" + item.id],
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "add-placeholder" }, [
                              _c("i", { staticClass: "fa fa-plus" }),
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "tooltip bottom" }, [
                              _vm._v(_vm._s(item.name)),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ]),
                ]
              ),
            ]),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "Toolbar",
        { staticClass: "justify-content-end" },
        [
          _c(
            "Btn",
            [
              _c(
                "router-link",
                { attrs: { tag: "span", to: "/parameters/ppes" } },
                [_vm._v(_vm._s(_vm.$t("global.cancel")))]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "Btn",
            {
              directives: [
                {
                  name: "can",
                  rawName: "v-can",
                  value: "beepiz-edit-ppes",
                  expression: "'beepiz-edit-ppes'",
                },
              ],
              staticClass: "primary",
              nativeOn: {
                click: function ($event) {
                  $event.stopPropagation()
                  return _vm.validForm()
                },
              },
            },
            [
              _vm._v(
                "\n            " + _vm._s(_vm.$t("global.save")) + "\n        "
              ),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }